import CustomTable from "../../../components/CustomTable/CustomTable";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { getSettlementColumns } from "./getSettlementColumns";
import { useNavigate } from "react-router-dom";
import {
  TABLE_COLUMN_DEFAULTS,
  buildTableScreenKey,
} from "../../../constants/tableColumnDefaults";

const SettlementTable = ({ data, onColumnControlChange }) => {
  const { loading } = useSelector((state) => state.settlement);
  const navigate = useNavigate()

  const columns = useMemo(
    () =>
      getSettlementColumns({
        onAssign: (txnId) => navigate(`/settlements/settlement-details/${txnId}`),
      }),
    [navigate]
  );

  return (
    <CustomTable
      rowKey="txnId"
      columns={columns}
      dataSource={data}
      loading={loading}
      screenKey={buildTableScreenKey("settlements")}
      defaultColumnKeys={TABLE_COLUMN_DEFAULTS.settlements}
      onColumnControlChange={onColumnControlChange}
    />
  );
};

export default SettlementTable;
